import { memo, useMemo } from 'react';

import { Button } from '@air/primitive-button';
import { DropdownMenu, DropdownMenuItem, DropdownMenuLabel } from '@air/primitive-dropdown-menu';

import { PLAYER_TIME_FORMAT_LABEL_MAP, PlayerTimeFormat } from '../constants/timeFormat';
import { usePlayerStore } from './PlayerContextProvider';
import { PlayerTimeFormatFrames } from './PlayerTimeFormatFrames';
import { PlayerTimeFormatStandard } from './PlayerTimeFormatStandard';
import { PlayerTimeFormatTimecode } from './PlayerTimeFormatTimecode';

export type PlayerTimeFormatButtonProps = {
  duration?: number;
  frameCount?: number;
};

export const PlayerTimeFormatButton = memo(({ duration, frameCount }: PlayerTimeFormatButtonProps) => {
  const timeFormat = usePlayerStore((state) => state.timeFormat);
  const setTimeFormat = usePlayerStore((state) => state.setTimeFormat);

  const timeFormatElement = useMemo(() => {
    switch (timeFormat) {
      case PlayerTimeFormat.Frames:
        return <PlayerTimeFormatFrames frameCount={frameCount} />;
      case PlayerTimeFormat.Standard:
        return <PlayerTimeFormatStandard duration={duration} />;
      case PlayerTimeFormat.Timecode:
        return <PlayerTimeFormatTimecode frameCount={frameCount} />;
    }
  }, [timeFormat, frameCount, duration]);

  return (
    <DropdownMenu
      side="top"
      trigger={
        <Button appearance="ghost" color="gray" size="small">
          {timeFormatElement}
        </Button>
      }
    >
      <DropdownMenuLabel>Time Format</DropdownMenuLabel>
      {Object.values(PlayerTimeFormat).map((format) => (
        <DropdownMenuItem
          data-id={format}
          key={format}
          label={PLAYER_TIME_FORMAT_LABEL_MAP[format]}
          onSelect={() => setTimeFormat(format)}
        />
      ))}
    </DropdownMenu>
  );
});

PlayerTimeFormatButton.displayName = 'PlayerTimeFormatButton';
